import { render, staticRenderFns } from "./post-card__footer.vue?vue&type=template&id=0eeb3313&lang=pug&"
import script from "./post-card__footer.vue?vue&type=script&lang=js&"
export * from "./post-card__footer.vue?vue&type=script&lang=js&"
import style0 from "./post-card__footer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports